import { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { DoorOpen, Hand, HeartPulse, BellRing } from 'lucide-react';
import { RangoSelector } from '@/components/aperturas/shared';

const TABS = [
  { to: '/aperturas', label: 'Resumen', icon: DoorOpen, end: true },
  { to: '/aperturas/manuales', label: 'Manuales', icon: Hand, end: false },
  { to: '/aperturas/salud', label: 'Salud', icon: HeartPulse, end: false },
  { to: '/aperturas/timbres', label: 'Timbres', icon: BellRing, end: false },
];

/** Shared by every tab through the outlet, so switching view keeps the period. */
export interface AperturasContext {
  days: number;
}

/**
 * Wraps the four Aperturas views in one page with tabs, rather than four
 * sidebar entries. Each tab keeps its own route so a view stays linkable and
 * the browser's back button behaves.
 */
export default function AperturasLayout() {
  const [days, setDays] = useState(90);

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div className="flex items-start justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="bg-sereno-dark p-2.5 rounded-xl text-white"><DoorOpen size={22} /></div>
          <div>
            <h1 className="text-2xl font-bold text-sereno-dark">Aperturas</h1>
            <p className="text-slate-500 text-sm mt-0.5">
              Cómo y cuándo se usan las puertas, a partir de los eventos que registran las cerraduras Nuki.
            </p>
          </div>
        </div>
        <RangoSelector days={days} onChange={setDays} />
      </div>

      <div className="border-b border-slate-200 dark:border-white/10">
        <nav className="flex gap-1 -mb-px overflow-x-auto">
          {TABS.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `flex items-center gap-1.5 px-4 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                  isActive
                    ? 'border-sereno-dark text-sereno-dark font-medium dark:border-white dark:text-white'
                    : 'border-transparent text-slate-500 hover:text-slate-700 dark:hover:text-slate-300'
                }`
              }
            >
              <Icon size={15} />
              {label}
            </NavLink>
          ))}
        </nav>
      </div>

      <Outlet context={{ days } satisfies AperturasContext} />
    </div>
  );
}
